import React, { useState, useContext, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import toast from "react-hot-toast";

import { AccountContext } from "context/account";
import api from "services/api";

function ChangePassword() {
  const { email } = useContext(AccountContext);
  const [mailSent, setSentMail] = useState(false);

  const handleResetPassword = async () => {
    try {
      await api.users.resetPasswordToken({ email: email });
      setSentMail(true);
    } catch (err) {
      toast.error("Send reset-password email failed!");
    }
  };

  return (
    <Card id="reset-password">
      <SuiBox p={3}>
        <SuiTypography variant="h5">Reset Password</SuiTypography>
      </SuiBox>
      <SuiBox pb={3} px={3}>
        <SuiBox mb={1}>
          <SuiTypography variant="body1" color="text">
            we'll send you instructions to <span className="italic font-semibold">{email}</span> on
            how to reset your password.
          </SuiTypography>
        </SuiBox>
        {mailSent ? (
          <div className="rounded-rounded p-base flex gap-x-small mt-large">
            <div className="flex flex-col gap-y-2xsmall">
              <SuiTypography
                variant="h6"
                fontWeight="medium"
                className="flex items-center"
                color="success"
              >
                Email has been successfully sent to you. Check your spam folder if you haven't
                received it after a few minutes.
              </SuiTypography>
            </div>
          </div>
        ) : null}
        <SuiBox display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap">
          <SuiBox ml="auto">
            <SuiButton variant="gradient" color="dark" onClick={handleResetPassword}>
              reset password
            </SuiButton>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    </Card>
  );
}

export default ChangePassword;
